<template>
  <div class="content">
    <div class="header text-center">
      <h3 class="title">Timeline</h3>
    </div>
    <div class="row">
      <div class="col-md-12">
        <time-line>
          <time-line-item
            v-for="(item, i) in tableItems"
            :key="i"
            :inverted="i % 2 == 0"
            badge-type="danger"
            badge-icon="tim-icons icon-paper"
          >
            <span slot="header" class="badge badge-pill badge-danger">{{
              item.occurrenceDescription
            }}</span>
            <span
              v-if="item.hasAttachment"
              slot="header"
              class="badge badge-pill badge-danger button-anexo"
            >
              <a
                href="#"
                @click.prevent="openImage(item.occurrencyId)"
                style="color: white"
              >
                <i class="tim-icons icon-camera-18"></i>
              </a>
            </span>
            <p slot="content">{{ item.occurrenceDescription }}</p>
            <h6 slot="footer">{{ item.occurrenceDate }}</h6>
          </time-line-item>

          <!-- <time-line-item
            v-for="(item, i) in tableItems"
            :key="i"
            badge-type="warning"
            badge-icon="tim-icons icon-app"
          >
            <span
              slot="header"
              class="badge badge-pill badge-warning"
            >{{item.occurrenceDescription}}</span>
            <p slot="content">{{ item.occurrenceDescription }}</p>
            <h6 slot="footer">{{ item.occurrenceDate }}</h6>
          </time-line-item>-->

          <!-- <time-line-item inverted badge-type="danger" badge-icon="tim-icons icon-paper">
            <span slot="header" class="badge badge-pill badge-danger">Nota fiscal emitida</span>
            <p
              slot="content"
            >A nota fiscal acabou de ser emitida e logo a transportadora irá efetuar a coleta da mercadoria.</p>
          </time-line-item>-->

          <!-- <time-line-item badge-type="warning" badge-icon="tim-icons icon-app">
            <span slot="header" class="badge badge-pill badge-warning">Mercadoria coletada</span>
            <p slot="content">A transportadora efetuou a coleta da mercadoria.</p>
          </time-line-item>-->

          <!-- <time-line-item inverted badge-type="info" badge-icon="tim-icons icon-square-pin">
            <span slot="header" class="badge badge-pill badge-info">Em rota para a entrega</span>

            <p
              slot="content"
            >A mercadoria já está a caminho para o seu endereço de entrega com previsão para até 27/08/2020 às 15:00h.</p>
          </time-line-item>-->
          <!-- 
          <time-line-item badge-type="success" badge-icon="tim-icons icon-satisfied">
            <span slot="header" class="badge badge-pill badge-success">Entrega realizada</span>
            <span slot="header" class="badge badge-pill badge-success button-anexo">
              <a href="#" @click.prevent="openImage" style="color: white;">
                <i class="tim-icons icon-camera-18"></i>
              </a>
            </span>
            <p slot="content">A mercadoria foi entregue com sucesso.</p>
          </time-line-item>-->
        </time-line>
      </div>
    </div>
    <fullscreen-sidebar ref="fullscreenSidebar">
      <template v-slot:content>
        <img :src="getAttachmentUrl" class="fullscreen-sidebar-img" />
        <!-- <img src="img/comprovante.jpg" style="width: 100%;" /> -->
      </template>
    </fullscreen-sidebar>
  </div>
</template>
<script>
import { TimeLine, TimeLineItem } from "src/components";
import FullscreenSidebar from "@/components_rms/FullscreenSidebar.vue";

export default {
  components: {
    "fullscreen-sidebar": FullscreenSidebar,
    TimeLine,
    TimeLineItem,
  },
  props: {
    id: String,
  },
  data: function () {
    return {
      occurrencyId: null,
      tableItems: [],
    };
  },
  computed: {
    getAttachmentUrl() {
      if (this.occurrencyId) {
        return `${this.$store.state.urlTracking}/deliveryoccurrency/attachment/${this.occurrencyId.toString()}`;
      }
      // return "img/comprovante.jpg";
      return ""; // return "img/comprovante.jpg"
    },
  },
  created() {
    this.loadData();
  },
  methods: {
    openImage(occurrencyId) {
      this.occurrencyId = occurrencyId;
      this.$refs.fullscreenSidebar.open();
    },
    async loadData() {
      this.$api
        .get("/deliveryoccurrency/get/" + this.id)
        .then((response) => {
          this.tableItems = response.data;
        })
        .catch((err) => {
          console.log(err);
          console.log(err.response);
          if (err.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          }
        });
    },
  },
};
</script>
<style scoped>
.fullscreen-sidebar-img {
  /* zoom: 2; increase if you have very small images */
  margin: auto;
  height: auto;
  max-height: 100%;
  width: auto;
  max-width: 100%;
}
</style>
